import React from 'react';
import { Link } from 'react-router-dom';
import { dateToTimezone } from './../../../utils';

const Header = (props) => {
    let name = null;
    if (props.user) {
        if (props.user.username === 'uthealth.punchout') {
            let nameParts = [];
            if (props.cxmlData.first_name) {
                nameParts.push(props.cxmlData.first_name);
            }
            if (props.cxmlData.last_name) {
                nameParts.push(props.cxmlData.last_name);
            }
            name = nameParts.join(' ');
            if (name === '') {
                name = 'Coupa';
            }
        } else {
            name = props.user.name;
        }
    }

    const handleSwitch = () => {
        props.clearPlatformType();
        props.history.push('/');
    };

    const handleHelpDesk = () => {
        props.showHelpModal();
    };

    let lastLogin = null;
    if (props.user && props.user.last_login) {
        lastLogin = <div className="last-login">(Last Login: {dateToTimezone(props.user.last_login, 'MM/DD/YYYY h:mm a')})</div>;
    }

    const handleChecks = () => {
        props.history.push('/template/1/12');
    };

    let checksIcon = null;
    if (props.cxmlData.buyer_cookie != null && ['pamela.h.butler@uth.tmc.edu', 'nicole.l.brown@uth.tmc.edu', 'robina.a.philipose@uth.tmc.edu'].includes(props.cxmlData.email.toLowerCase())) {
        checksIcon = <div className="checks" onClick={handleChecks}><img src="https://ac-ut-health.s3.amazonaws.com/check-icon.png" alt="Checks" /></div>;
    }
    // 172: diego.admin, 175: hugh.admin, 242: christy.admin
    if (props.user != null && ([172, 175, 242].includes(parseInt(props.user.id)) || props.user.username === 'site.admin')) {
        checksIcon = <div className="checks" onClick={handleChecks}><img src="https://ac-ut-health.s3.amazonaws.com/check-icon.png" alt="Checks" /></div>;
    }

    return (
        <div className="header-container">
            <div className="title">{props.title}</div>
            <div className="right-menu">
                {checksIcon}
                <div className="switch" onClick={handleSwitch}><i className="fas fa-exchange-alt" /> Switch Organization</div>
                <div className="help-desk" onClick={handleHelpDesk}><i className="fas fa-question-circle" /> Help Desk</div>
                <div className="username">
                    <div><i className="fas fa-user" /> Welcome back <span>{name}</span></div>
                    {lastLogin}
                </div>
                <div className="sign-out">
                    <Link to="#" onClick={props.logoutHandler}><i className="fas fa-sign-out-alt" /> Sign Out</Link>
                </div>
            </div>
        </div>
    );
}

export default Header;
